// Observe the existing app mount; never initialize or duplicate Growave widgets.
// The server-rendered store review source remains visible until the app paints.
class TbwlPurchaseTrust extends HTMLElement {
  connectedCallback() {
    const provider = this.querySelector('[data-trust-provider]');
    const fallback = this.querySelector('[data-trust-fallback]');
    this.observer?.disconnect();
    this.observer = new ResizeObserver(() => {
      const mount = provider.querySelector('.gw-rv-star-rating-widget-placeholder');
      fallback.hidden = Boolean(mount && mount.getBoundingClientRect().height > 16);
    });
    this.observer.observe(provider);
  }
  disconnectedCallback() { this.observer?.disconnect(); }
}
if (!customElements.get('tbwl-purchase-trust')) customElements.define('tbwl-purchase-trust', TbwlPurchaseTrust);
